const ONE_TIME_PASSWORD_TYPES = {
    pin: "pin",
    otp: "otp",
    web: "web",
    webReset: "web-reset",
    signUp: "signup"
}

export {ONE_TIME_PASSWORD_TYPES}
